/* Quasipara · Pop — interações */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var strings = window.qpStrings || { added: 'ADICIONADO ✓', viewCart: 'Ver carrinho', error: 'Não foi possível adicionar. Tenta outra vez.' };
  var toastTimer = null;

  /* ---------- Toast ---------- */
  function showToast(message, withCartButton) {
    var old = document.querySelector('.qp-toast');
    if (old) old.remove();
    if (toastTimer) clearTimeout(toastTimer);

    var toast = document.createElement('div');
    toast.className = 'qp-toast';
    toast.setAttribute('role', 'status');
    var text = document.createElement('span');
    text.textContent = message;
    toast.appendChild(text);

    if (withCartButton) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = strings.viewCart;
      btn.addEventListener('click', function () {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open(btn);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
        hideToast(toast);
      });
      toast.appendChild(btn);
    }

    document.body.appendChild(toast);
    toastTimer = setTimeout(function () { hideToast(toast); }, 2800);
  }

  function hideToast(toast) {
    if (!toast || !toast.isConnected) return;
    toast.classList.add('is-leaving');
    setTimeout(function () { toast.remove(); }, 260);
  }

  /* ---------- Confetti ---------- */
  var sparkColors = ['#FFB5D8', '#D7FF3A', '#B8F0D8', '#FFE36E', '#DCE0FF', '#2B3BFF'];
  function burst(el) {
    if (reduceMotion || !el) return;
    var r = el.getBoundingClientRect();
    var cx = r.left + r.width / 2;
    var cy = r.top + r.height / 2;
    for (var i = 0; i < 12; i++) {
      var s = document.createElement('span');
      s.className = 'qp-spark';
      var angle = (Math.PI * 2 * i) / 12 + Math.random() * 0.4;
      var dist = 70 + Math.random() * 70;
      s.style.left = cx + 'px';
      s.style.top = cy + 'px';
      s.style.background = sparkColors[i % sparkColors.length];
      s.style.setProperty('--dx', Math.round(Math.cos(angle) * dist) + 'px');
      s.style.setProperty('--dy', Math.round(Math.sin(angle) * dist - 30) + 'px');
      document.body.appendChild(s);
      setTimeout(function (node) { node.remove(); }, 800, s);
    }
  }

  /* ---------- Adicionar rápido (grelha da página inicial) ---------- */
  function updateCartSections(sections) {
    if (!sections) return;
    var parser = new DOMParser();
    var drawer = document.querySelector('cart-drawer');

    if (sections['cart-drawer']) {
      var target = document.querySelector('#CartDrawer');
      var doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
      var source = doc.querySelector('#CartDrawer');
      if (target && source) {
        target.innerHTML = source.innerHTML;
        if (drawer) {
          drawer.classList.remove('is-empty');
          var inner = drawer.querySelector('.drawer__inner');
          if (inner) inner.classList.remove('is-empty');
          var overlay = drawer.querySelector('#CartDrawer-Overlay');
          if (overlay && typeof drawer.close === 'function') overlay.addEventListener('click', drawer.close.bind(drawer));
        }
      }
    }

    if (sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      var bubbleDoc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
      var bubbleSource = bubbleDoc.querySelector('.shopify-section');
      if (bubble && bubbleSource) bubble.innerHTML = bubbleSource.innerHTML;
    }
  }

  function quickAdd(button) {
    if (button.getAttribute('aria-disabled') === 'true') return;
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('is-loading');

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message || 'error');
        updateCartSections(data.sections);
        button.classList.add('is-added');
        var label = button.querySelector('[data-qp-add-label]');
        if (label) label.textContent = button.getAttribute('data-added-text') || '✓';
        button.setAttribute('aria-label', button.getAttribute('data-added-aria') || strings.added);
        burst(button);
        showToast(strings.added, true);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'qp-quick-add', productVariantId: variantId, cartData: data });
        }
      })
      .catch(function () {
        showToast(strings.error, false);
      })
      .finally(function () {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-disabled');
      });
  }

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-qp-add]');
    if (addBtn) {
      e.preventDefault();
      quickAdd(addBtn);
      return;
    }

    var chip = e.target.closest('[data-qp-filter]');
    if (chip) {
      var root = chip.closest('[data-qp-grid]');
      if (!root) return;
      var value = chip.getAttribute('data-qp-filter');
      root.querySelectorAll('[data-qp-filter]').forEach(function (c) {
        c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
      });
      var shown = 0;
      root.querySelectorAll('[data-qp-item]').forEach(function (item) {
        var list = (item.getAttribute('data-qp-collections') || '').split(',');
        var show = value === 'all' || list.indexOf(value) !== -1;
        item.hidden = !show;
        if (show) {
          shown++;
          item.classList.remove('qp-in');
          void item.offsetWidth;
          item.classList.add('qp-in');
        }
      });
      var empty = root.querySelector('[data-qp-empty]');
      if (empty) empty.hidden = shown !== 0;
    }
  });

  /* ---------- Bola que segue o rato (hero) ---------- */
  function initBlob(area) {
    var blob = area.querySelector('.qp-blob');
    if (!blob || reduceMotion || !window.matchMedia('(hover: hover)').matches) return;
    var raf = null;
    var x = 0;
    var y = 0;
    area.addEventListener('pointermove', function (e) {
      var r = area.getBoundingClientRect();
      x = e.clientX - r.left;
      y = e.clientY - r.top;
      if (raf) return;
      raf = requestAnimationFrame(function () {
        blob.style.transform = 'translate(' + x + 'px,' + y + 'px)';
        blob.style.opacity = '0.9';
        raf = null;
      });
    });
    area.addEventListener('pointerleave', function () { blob.style.opacity = '0'; });
  }

  /* ---------- Barra fixa de compra (produto): sempre visível ---------- */
  function initSticky(bar) {
    var mainButton = document.querySelector('product-form .product-form__submit');
    var form = document.querySelector('product-form form');
    if (!mainButton || !form) {
      bar.remove();
      return;
    }
    document.body.classList.add('qp-has-sticky');
    var action = bar.querySelector('[data-qp-sticky-add]');
    var buyNow = bar.querySelector('[data-qp-sticky-buy]');
    var priceEl = bar.querySelector('[data-qp-sticky-price]');

    function setDisabled(el, disabled) {
      if (!el) return;
      if (disabled) el.setAttribute('aria-disabled', 'true');
      else el.removeAttribute('aria-disabled');
    }

    function syncState() {
      var price = document.querySelector('.product .price .price-item--last') ||
        document.querySelector('.product .price__regular .price-item--regular');
      if (price && priceEl) priceEl.textContent = price.textContent.trim();
      var soldOut = mainButton.hasAttribute('disabled');
      setDisabled(action, soldOut);
      setDisabled(buyNow, soldOut);
    }
    syncState();

    // Packs (app de bundles): o botão principal é intercetado pela app, por isso usamos sempre esse clique.
    function hasBundle() { return !!document.querySelector('.rapi-bundles'); }
    var priceBox = document.querySelector('.product .price');
    if (priceBox && 'MutationObserver' in window) {
      new MutationObserver(function () { syncState(); }).observe(priceBox, { childList: true, subtree: true, characterData: true });
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('.rapi-bundles')) setTimeout(syncState, 120);
    });

    if (action) {
      action.addEventListener('click', function () {
        if (action.getAttribute('aria-disabled') === 'true') return;
        mainButton.click();
      });
    }

    function cartCount() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { return c.item_count || 0; });
    }

    // Compra rápida: adiciona o artigo escolhido e segue direto para o checkout (onde está o MB WAY).
    if (buyNow) {
      buyNow.addEventListener('click', function () {
        if (buyNow.getAttribute('aria-disabled') === 'true') return;
        setDisabled(buyNow, true);
        burst(buyNow);
        if (hasBundle()) {
          cartCount().then(function (before) {
            mainButton.click();
            var tries = 0;
            (function poll() {
              tries++;
              cartCount().then(function (now) {
                if (now > before) { window.location.href = '/checkout'; return; }
                if (tries < 16) { setTimeout(poll, 400); return; }
                setDisabled(buyNow, false);
                showToast(strings.error, false);
              });
            })();
          });
          return;
        }
        var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
        fetch(addUrl + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (data.status) throw new Error(data.description || data.message || 'error');
            window.location.href = '/checkout';
          })
          .catch(function () {
            setDisabled(buyNow, false);
            showToast(strings.error, false);
          });
      });
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(syncState, 60); });
    }
  }

  /* ---------- Cursor animado em todo o site (desktop) ---------- */
  function initCursor() {
    if (reduceMotion || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (document.querySelector('.qp-cursor')) return;

    var dot = document.createElement('div');
    dot.className = 'qp-cursor';
    dot.setAttribute('aria-hidden', 'true');
    var ring = document.createElement('div');
    ring.className = 'qp-cursor-ring';
    ring.setAttribute('aria-hidden', 'true');
    document.body.appendChild(ring);
    document.body.appendChild(dot);

    var mx = -100, my = -100, rx = -100, ry = -100;
    var visible = false;

    document.addEventListener('pointermove', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      mx = e.clientX;
      my = e.clientY;
      if (!visible) {
        visible = true;
        rx = mx;
        ry = my;
        document.documentElement.classList.add('qp-cursor-on');
      }
      dot.style.transform = 'translate(' + mx + 'px,' + my + 'px)';
    }, { passive: true });

    document.addEventListener('pointerleave', function () {
      visible = false;
      document.documentElement.classList.remove('qp-cursor-on');
    });
    document.documentElement.addEventListener('mouseleave', function () {
      visible = false;
      document.documentElement.classList.remove('qp-cursor-on');
    });

    var interactive = 'a, button, summary, label, input, select, textarea, [role="button"], .qp-card, .card-wrapper';
    document.addEventListener('pointerover', function (e) {
      document.documentElement.classList.toggle('qp-cursor-hover', !!e.target.closest(interactive));
    });
    document.addEventListener('pointerdown', function () { document.documentElement.classList.add('qp-cursor-down'); });
    document.addEventListener('pointerup', function () { document.documentElement.classList.remove('qp-cursor-down'); });

    (function loop() {
      rx += (mx - rx) * 0.18;
      ry += (my - ry) * 0.18;
      ring.style.transform = 'translate(' + rx.toFixed(1) + 'px,' + ry.toFixed(1) + 'px)';
      requestAnimationFrame(loop);
    })();
  }

  /* ---------- Confetti ao adicionar na página de produto ---------- */
  function initProductFormFeedback() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source !== 'product-form') return;
      var btn = document.querySelector('product-form .product-form__submit');
      var stickyBtn = document.querySelector('[data-qp-sticky-add]');
      var target = stickyBtn && document.activeElement === stickyBtn ? stickyBtn : btn;
      if (target) burst(target);
      [btn, stickyBtn].forEach(function (b) {
        if (!b) return;
        b.classList.add('qp-added');
        setTimeout(function () { b.classList.remove('qp-added'); }, 1800);
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-qp-blob-area]').forEach(initBlob);
    document.querySelectorAll('[data-qp-sticky]').forEach(initSticky);
    initProductFormFeedback();
    initCursor();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-qp-blob-area]').forEach(initBlob);
  });
})();
